export const getSectionAssetUploadPath = (sectionId: number) => {
	const sectionAssetUploadPath = `/site/page-sections/${sectionId}/asset`;

	return sectionAssetUploadPath;
};
